import apiClient from "../../../utils/api.client";

// NOTE: For all the EP in this file, ask whether organization is needed or not

const createDetail = async (orderID, payload) => {
  try {
    const url = `/delivery-service/orders/${orderID}/detail`;
    const response = await apiClient.post(url, payload);
    const data = response.data;

    return data;
  } catch (error) {
    throw new Error({ error, isServiceException: true });
  }
};

const deleteDetail = async (orderID, detailID) => {
  // return fetch(`${getServiceUrl()}/orders/${orderID}/detail/${detailID}`, {
  //   method: "DELETE",
  //   headers: { "Content-Type": "application/json" },
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.status;
  //     } else {
  //       throw new Error({ res, isServiceException: true })
  //     }
  //   })
  //   .catch(async e => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw new Error({ res, isServiceException: true })
  //     }
  //   })
  try {
    const url = `/delivery-service/orders/${orderID}/detail/${detailID}`;
    const response = await apiClient.delete(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at deleteDetail EP: ", error);
    throw error;
  }
};

const ordersDetailService = {
  createDetail,
  deleteDetail,
};

export default ordersDetailService;
